export enum CurrentFlow {
  FinancialCheckup = 'FINANCIAL CHECKUP',
  DebtConsolidation = 'DEBT CONSOLIDATION',
  StudentLoanForgiveness = 'STUDENT LOAN FORGIVENESS',
  Card = 'CARD',
  MissedPayment = 'MISSED PAYMENT',
  AICoach = 'AI COACH',
}
